/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "PB_N8raAIb4",
    title: "Monica and Chandler | Their Story",
    thumbnail: "https://img.youtube.com/vi/PB_N8raAIb4/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=PB_N8raAIb4",
    playtime: "5:18",
    author: "HBO Max",
    authorImg:
      "https://yt3.ggpht.com/TcXFMFkDeUN8pDqZ-2WShXiG6lXtpoRG2kfRMg3Nd9g947mESyRYqlWtwcoy9FyjiiLVLaTd=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Sep 20, 2021",
    views: 165_658,
    category: "Television",
  },
  {
    _id: "e-ORhEE9VVg",
    title: "Taylor Swift - Blank Space",
    thumbnail: "https://img.youtube.com/vi/e-ORhEE9VVg/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=e-ORhEE9VVg&ab_channel=TaylorSwiftVEVO",
    playtime: "4:32",
    author: "Taylor Swift VEVO",
    authorImg:
      "https://yt3.ggpht.com/MqKm9xyjonzkICKA78ir0AM-WUR47ntkBeJlgHeIk_rUnPuukiWtzOEmU7UjO8cFoPrBatCh3As=s88-c-k-c0x00ffffff-no-nd-rj",
    dateUploaded: "Nov 10, 2014",
    views: 2_971_589_897,
    category: "Music",
  },
  {
    _id: "NHhKX1ZMHYc",
    title: "Nagisa God mode",
    thumbnail: "https://img.youtube.com/vi/NHhKX1ZMHYc/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=NHhKX1ZMHYc&ab_channel=AizenSousuke",
    playtime: "1:50",
    author: "Aizen Susuke",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSNzWodXTf7M6_KNB9XgTtVWzNg2TwI81TlKeUH=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Jul 10, 2020",
    views: 213_239,
    category: "Anime",
  },
  {
    _id: "lnbQGTQ1mw8",
    title: "Naruto Vs Pain AMV -[Skillet] Hero/Monster HD",
    thumbnail: "https://img.youtube.com/vi/lnbQGTQ1mw8/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=lnbQGTQ1mw8&ab_channel=D-Deca",
    playtime: "6:08",
    author: "D- Deca",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLTvkfDR5z6Ttn1uRb7j89XsVc6gRE-rrL9WCUar=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Aug 13, 2015",
    views: 6_231_509,
    category: "Anime",
  },
  {
    _id: "jHNNMj5bNQw",
    title:
      "Kabira Full Song | Yeh Jawaani Hai Deewani | Pritam | Ranbir Kapoor, Deepika Padukone",
    thumbnail: "https://img.youtube.com/vi/jHNNMj5bNQw/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=jHNNMj5bNQw&ab_channel=T-Series",
    playtime: "4:11",
    author: "T-Series",
    authorImg:
      "https://yt3.ggpht.com/hTPDN-Yr7vQCEJ-YxDyH6OiSAMUcPd0gW40Dxy4299GFFBPh3lumCXIZhMQnOVGV6n3a1GL4BQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Jul 10, 2013",
    views: 319_743_594,
    category: "Music",
  },
  {
    _id: "_mDxcDjg9P4",
    title: "Vampire Weekend - Step (Official Lyrics Video)",
    thumbnail: "https://img.youtube.com/vi/_mDxcDjg9P4/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=_mDxcDjg9P4&ab_channel=VampireWeekendVEVO",
    playtime: "4:11",
    author: "Vampire Weekend",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLRZRKI2gjluwymQQrn_WolN6HeMvagChZjPorPk=s88-c-k-c0x00ffffff-no-rj-mo",
    dateUploaded: "Mar 19, 2013",
    views: 21_822_208,
    category: "Music",
  },
  {
    _id: "OSyKhqDsW14",
    title: "Goku Vs. Jiren「AMV」- Get Me Out",
    thumbnail: "https://img.youtube.com/vi/OSyKhqDsW14/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=OSyKhqDsW14&ab_channel=ReinelexMusic",
    playtime: "3:43",
    author: "Reinelex Music",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLRDGX6t7z1kcwerj8DLaplx0xTbuDvIXmXbKBz13A=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Oct 8, 2017",
    views: 5_478_12,
    category: "Anime",
  },
  {
    _id: "QTwRrg0bJ8I",
    title: "[AMV」Dragon Ball Super: Centuries",
    thumbnail: "https://img.youtube.com/vi/QTwRrg0bJ8I/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=QTwRrg0bJ8I&ab_channel=SanjinoKanta",
    playtime: "3:48",
    author: "Sanjino Kanta",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLRc4ff0eFCrjsvCcJt7AdzwYl9mGbVTDQkt3qJXVQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Mar 4, 2018",
    views: 7_555_662,
    category: "Anime",
  },
  {
    _id: "XbhecuoEgxs",
    title: "Kung Fu Panda | Who Are You",
    thumbnail: "https://img.youtube.com/vi/XbhecuoEgxs/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=XbhecuoEgxs&ab_channel=KhaledOsman",
    playtime: "6:04",
    author: "Khaled Osman",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSWPTePakGs-gnsKO0eDgshcv8O6JnHJ-89-G7Z=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Jan 3, 2021",
    views: 7_555_662,
    category: "Anime",
  },
  {
    _id: "km2OPUctni4",
    title: "Saitama vs Genos Fight | One Punch Man (60FPS)",
    thumbnail: "https://img.youtube.com/vi/km2OPUctni4/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=km2OPUctni4&ab_channel=60FpsStation",
    playtime: "3:55",
    author: "60FpsStation",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSWPTePakGs-gnsKO0eDgshcv8O6JnHJ-89-G7Z=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Oct 19, 2016",
    views: 28_381_303,
    category: "Anime",
  },
  {
    _id: "ZzuFVbVHfYY",
    title: "Code Geass Top 6 Lelouch Epic Moments",
    thumbnail: "https://img.youtube.com/vi/ZzuFVbVHfYY/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=ZzuFVbVHfYY&ab_channel=AnimeClub2020",
    playtime: "6:04",
    author: "AnimeClub2020",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLRvjZXZ1qpZmdUi_hX_llUoJhLOf6vNWBoy-mza=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Sep 18, 2020",
    views: 7_568_452,
    category: "Anime",
  },
  {
    _id: "NlJZ-YgAt-c",
    title: "Death Note | OFFICIAL TRAILER",
    thumbnail: "https://img.youtube.com/vi/NlJZ-YgAt-c/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=NlJZ-YgAt-c&ab_channel=CrunchyrollCollection",
    playtime: "1:51",
    author: "CrunchyrollCollection",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSJCpLUOWSXEfOBhyGnmYCp8h7gEseLhZNw8F-xRA=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Dec 16, 2019",
    views: 1_265_75,
    category: "Anime",
  },
  {
    _id: "284Ov7ysmfA",
    title:
      "Channa Mereya Full Video - ADHM|Ranbir Kapoor, Anushka|Arijit Singh|Pritam|Karan Johar",
    thumbnail: "https://img.youtube.com/vi/284Ov7ysmfA/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=284Ov7ysmfA&ab_channel=SonyMusicIndiaVEVO",
    playtime: "3:03",
    author: "SonyMusicIndiaVEVO",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLQb29pcnUPnEwJ3kIHBHVPXptRbELdoEkdDnxPRrQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Sept 4, 2017",
    views: 176_294_765,
    category: "Music",
  },
  {
    _id: "TByW5-HDYTA",
    title: "One Punch Man (Season 1) - Episode 05 [English Sub]",
    thumbnail: "https://img.youtube.com/vi/TByW5-HDYTA/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=TByW5-HDYTA&ab_channel=MuseAsia",
    playtime: "24:29",
    author: "MuseAsia",
    authorImg:
      "https://yt3.ggpht.com/xdgNgosFHeVJ8BNdypwReOje1Luer4O521yV1-k5lVWRuRdmHzq9kLsNz9eVLRBCewW56fP9CQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Feb 28, 2022",
    views: 15_318_230,
    category: "Anime",
  },
  {
    _id: "2iRqm4CFSmc",
    title: "Saitama vs Suiryu",
    thumbnail: "https://img.youtube.com/vi/2iRqm4CFSmc/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=2iRqm4CFSmc&ab_channel=SuperSaitama",
    playtime: "3:08",
    author: "SuperSaitama",
    authorImg:
      "https://yt3.ggpht.com/xdgNgosFHeVJ8BNdypwReOje1Luer4O521yV1-k5lVWRuRdmHzq9kLsNz9eVLRBCewW56fP9CQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Apr 19, 2021",
    views: 7_190_567,
    category: "Anime",
  },
  {
    _id: "fjpBvXnp2Lo",
    title: "Who Came on to Whom? | Friends",
    thumbnail: "https://img.youtube.com/vi/fjpBvXnp2Lo/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=fjpBvXnp2Lo&ab_channel=Friends",
    playtime: "5:52",
    author: "Friends",
    authorImg:
      "https://yt3.ggpht.com/Jv_qPbZo8iNMT9W2v6ZQRb3chJJZDFMI2MiIbd57_zJcvcBYUusmJfdN5-3rdWZ95CsbJ7Ro=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "May 8, 2022",
    views: 537_942,
    category: "Television",
  },
  {
    _id: "11fJ18huVSg",
    title: "DBS - Goku's little surprise to other God's",
    thumbnail: "https://img.youtube.com/vi/11fJ18huVSg/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=11fJ18huVSg&ab_channel=GBG",
    playtime: "2:32",
    author: "GBG",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSJCpLUOWSXEfOBhyGnmYCp8h7gEseLhZNw8F-xRA=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Mar 6, 2017",
    views: 3_446_556,
    category: "Anime",
  },
  {
    _id: "hIbcd_Fncvw",
    title: "the office try not to laugh challenge | Comedy Bites",
    thumbnail: "https://img.youtube.com/vi/hIbcd_Fncvw/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=hIbcd_Fncvw&ab_channel=ComedyBites",
    playtime: "8:20",
    author: "Comedy Bites",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLQ7gagRpB0kUMV8WISSD54DN2XFwqTkVY0oaOHU=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Apr 4, 2022",
    views: 1_512_937,
    category: "Television",
  },
  {
    _id: "XHViAiVuDsA",
    title: "Code Geass - Continued Story",
    thumbnail: "https://img.youtube.com/vi/XHViAiVuDsA/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=XHViAiVuDsA&ab_channel=Lu5ck",
    playtime: "5:13",
    author: "Lu5ck",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLR-BZT28k8oSeh1lfr4FagUJncKVNWK9kXZ0YI3=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Oct 1, 2008",
    views: 6_462_192,
    category: "Anime",
  },
  {
    _id: "H5v3kku4y6Q",
    title: "Harry Styles - As It Was (Official Video)",
    thumbnail: "https://img.youtube.com/vi/H5v3kku4y6Q/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=H5v3kku4y6Q&ab_channel=HarryStylesVEVO",
    playtime: "2:45",
    author: "Harry Styles",
    authorImg:
      "https://yt3.ggpht.com/MjEWybBlBXVZigapX__tR_PyJRx-_OGwEZfWZKyS_jJrlgeeF67h69wN2HOhFohiDA7YNeIG=s88-c-k-c0x00ffffff-no-nd-rj",
    dateUploaded: "Apr 1, 2022",
    views: 133_956_873,
    category: "Music",
  },
  {
    _id: "syFZfO_wfMQ",
    title: "One Direction - Night Changes",
    thumbnail: "https://img.youtube.com/vi/syFZfO_wfMQ/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=syFZfO_wfMQ&ab_channel=OneDirectionVEVO",
    playtime: "4:00",
    author: "One Direction VEVO",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSFBSwphWiZqUpi2-jLevVvZbZh0P4coFq1TfQ1Y_E=s88-c-k-c0x00ffffff-no-rj-mo",
    dateUploaded: "Nov 21, 2014",
    views: 520_637_136,
    category: "Music",
  },
  {
    _id: "WaUhYg7mfl0",
    title: "Nagisa: Assassin Mode",
    thumbnail: "https://img.youtube.com/vi/WaUhYg7mfl0/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=WaUhYg7mfl0&ab_channel=EbelleLimbaga",
    playtime: "6:02",
    author: "Ebelle Limbaga",
    authorImg:
      "https://yt3.ggpht.com/LEbe8wH1b0T4RFh2HKZBETTWFEGv713vy9wBzKqZIlQLGrUiK6VJ4yUu0o2fOMI34Ac-9gc4bw=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Apr 24, 2021",
    views: 6_462_192,
    category: "Anime",
  },
  {
    _id: "fqt6xBtyDs4",
    title: "One Punch Man (Season 2) - Episode 18 [English Sub]",
    thumbnail: "https://img.youtube.com/vi/fqt6xBtyDs4/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=fqt6xBtyDs4&ab_channel=MuseAsia",
    playtime: "23:50",
    author: "Muse Asia",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLR-BZT28k8oSeh1lfr4FagUJncKVNWK9kXZ0YI3=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Oct 31, 2020",
    views: 4_535_586,
    category: "Anime",
  },
  {
    _id: "T94PHkuydcw",
    title:
      "Kun Faya Kun Full Video Song Rockstar | Ranbir Kapoor | A.R. Rahman, Javed Ali, Mohit Chauhan",
    thumbnail: "https://img.youtube.com/vi/T94PHkuydcw/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=T94PHkuydcw&ab_channel=T-Series",
    playtime: "6:20",
    author: "T-Series",
    authorImg:
      "https://yt3.ggpht.com/hTPDN-Yr7vQCEJ-YxDyH6OiSAMUcPd0gW40Dxy4299GFFBPh3lumCXIZhMQnOVGV6n3a1GL4BQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Dec 5, 2011",
    views: 300_659_763,
    category: "Music",
  },
  {
    _id: "5Eqb_-j3FDA",
    title: "Coke Studio | Season 14 | Pasoori | Ali Sethi x Shae Gill",
    thumbnail: "https://img.youtube.com/vi/5Eqb_-j3FDA/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=5Eqb_-j3FDA&ab_channel=CokeStudio",
    playtime: "4:36",
    author: "Coke Studio",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLTNtHgVmX114S4cnjoyFaDDJE6N1zNBwKgRNnYNAg=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Feb 7, 2022",
    views: 134_974_148,
    category: "Music",
  },

  {
    _id: "1ruo0arhFMw",
    title: "Death Note: The Best Moments",
    thumbnail: "https://img.youtube.com/vi/1ruo0arhFMw/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=1ruo0arhFMw&ab_channel=karlyharris",
    playtime: "2:32",
    author: "GBG",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSK-cBDAINpKsRmYdpsd63koMzEob4Z38VDxZzmyQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Mar 6, 2017",
    views: 5_054_256,
    category: "Anime",
  },
  {
    _id: "vpSBk4dzWlM",
    title: "nick miller being his adorkable self for 4 minutes straight",
    thumbnail: "https://img.youtube.com/vi/vpSBk4dzWlM/hqdefault.jpg",
    src: "https://www.youtube.com/watch?v=vpSBk4dzWlM&ab_channel=kay",
    playtime: "4:18",
    author: "kay",
    authorImg:
      "https://yt3.ggpht.com/ytc/AKedOLSK-cBDAINpKsRmYdpsd63koMzEob4Z38VDxZzmyQ=s88-c-k-c0x00ffffff-no-rj",
    dateUploaded: "Oct 10, 2021",
    views: 157_670,
    category: "Television",
  },
];
